import React, { useEffect } from "react";
import ManageHeader from "../../components/header/ManageHeader";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { /*chatScript,*/ removeChat } from "../../util/chatBotUtils";
import { connect } from "react-redux";
import { TextWrapper } from "../../constants/common/StyledGlobalConstants";
import Cookies from "js-cookie";
import { changeLanguageHandler } from "../../util/userLanguageUtils";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";

const { MOBILE } = DEVICE_BREAKPOINTS;

const Wrapper = styled.div`
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  align-items: ${(props) => props.alignItems};
  margin-top: ${(props) => props.marginTop};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
  font-family: ${(props) => props.fontFamily};
  line-height: ${(props) => props.lineHeight};
  word-break: ${(props) => props.wordBreak};
  height: ${(props) => props.height};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  gap: ${(props) => props.gap};
  @media (min-width: 1024px) {
    font-family: "neue-haas-grotesk-display";
  }
`;

function AccessDenied(props) {
  const { t, i18n } = useTranslation("loginTranslation");
  useEffect(() => {
    if (Cookies.get("userLanguage")) {
      i18n.changeLanguage(changeLanguageHandler(Cookies.get("userLanguage")));
    }
  }, []);
  const { windowSize } = props;

  useEffect(() => {
    removeChat(props.regionId, props.emailAddress);
    return () => {
      // if (props.emailAddress && (props.regionId === "840" || props.regionId === "124")) {
      //   chatScript(props.firstName, props.surname, props.emailAddress, props.phoneNumber);
      // }
    };
  }, []);

  useEffect(() => {
    document.title = t(`${props.title}`);
  }, [props.title]);

  return (
    <>
      <ManageHeader />
      <Wrapper display="flex" justifyContent="center">
        <Wrapper display="flex" flexDirection="column" height={"100vh"} justifyContent="center" padding="0rem 1rem" width="auto">
          <Wrapper>
            <TextWrapper
              tabIndex="0"
              aria-label="Access denied"
              fontSize={"40px"}
              fontWeight="bold"
              fontFamily={"neue-haas-grotesk-display"}
              wordBreak="break-all"
            >
              {t("Access denied")}
            </TextWrapper>
            <TextWrapper
              tabIndex="-1"
              fontSize={"14px"}
              marginTop={"16px !important"}
              lineHeight={"20px"}
              fontWeight="normal"
              wordBreak="break-word"
              style={{ maxWidth: `${windowSize.width >= MOBILE && "350px"}` }}
            >
              {t("You don’t have the necessary permissions to access this page.")} {t("To inquire about access, contact your administrator.")}
            </TextWrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    windowSize: state.ACCOUNT.windowSize,
    firstName: state.ACCOUNT.firstName,
    surname: state.ACCOUNT.surname,
    emailAddress: state.ACCOUNT.emailAddress,
    phoneNumber: state.ACCOUNT.accountUserTokenDetails.phoneNumber,
    regionId: state.ACCOUNT.regionId,
  };
};

AccessDenied.propTypes = {
  windowSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  firstName: PropTypes.string,
  surname: PropTypes.string,
  emailAddress: PropTypes.string,
  phoneNumber: PropTypes.string,
  regionId: PropTypes.string,
  title: PropTypes.string,
};

export default connect(mapStateToProps)(AccessDenied);
